export default __webpack_public_path__ + "static/media/rightVector.ef3e2bff.svg";